import styles from "./PageHeader.module.scss";
import FilterListOutlinedIcon from "@mui/icons-material/FilterListOutlined";
import { Button, Grid2 } from "@mui/material";

export default function PageHeader(props) {
  const {
    header,
    subheader,
    button,
    buttonClick,
    search,
    tabs,
    selectedTab,
    setSelectedTab,
    defaultTabIndex,
    disable,
    disableFunc,
    buttonThreeText,
    setShowFiltersFlag,
    filtersApplied,
    appliedFilters,
    filterClick,
    selectedValues, // Add this prop to receive selected filter values
    onRemoveFilter, // Add this prop to handle filter removal
    ...rest
  } = props;

  return (
    <Grid2 className={styles.mainContainer}>
      <Grid2 className={styles.headerandbutton}>
        <Grid2>
          <Grid2 className={styles.header}>{header}</Grid2>
          <Grid2 className={styles.subheader}>{subheader}</Grid2>
        </Grid2>
        <Grid2 className={styles.searchandbutton}>
          <Grid2 className={styles.button} onClick={buttonClick}>
            {button}
          </Grid2>
        </Grid2>
      </Grid2>
      <Grid2 className={styles.line} />
      <Grid2 className={styles.headerandbutton}>
        <Grid2 className={styles.Container} {...rest}>
          {tabs?.map((tab, index) => (
            <Grid2
              className={
                selectedTab.value === tab.value
                  ? `${styles.ActiveContainerItem} ActiveNavItem`
                  : `${styles.InActiveContainerItem} InActiveNavItem`
              }
              onClick={(evt) => {
                if (disable) {
                  tabs[defaultTabIndex].value === tab.value
                    ? setSelectedTab(evt, tab)
                    : disableFunc();
                } else {
                  setSelectedTab(evt, tab);
                }
              }}
              key={index}
            >
              {tab.title}
            </Grid2>
          ))}
        </Grid2>
        <Grid2 className={styles.searchandbutton}>
          <Grid2>
            {selectedValues?.map((value, index) => (
              <span
                key={index}
                className={styles.filterValue}
                onClick={() => onRemoveFilter(value)}
              >
                {value};
              </span>
            ))}
          </Grid2>
          <Grid2>
            {buttonThreeText && (
              <Button onClick={filterClick}>
                <FilterListOutlinedIcon />
              </Button>
            )}
          </Grid2>
        </Grid2>
      </Grid2>
    </Grid2>
  );
}
